import { render, staticRenderFns } from "./ISJInfoModal.vue?vue&type=template&id=145c6a98&scoped=true&"
import script from "./ISJInfoModal.vue?vue&type=script&lang=ts&"
export * from "./ISJInfoModal.vue?vue&type=script&lang=ts&"
import style0 from "./ISJInfoModal.vue?vue&type=style&index=0&id=145c6a98&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145c6a98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VExpansionPanels,VIcon})
